const _excluded = ["size"];
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
import React from "react";
var NoCosts24 = function NoCosts24(props) {
  return /*#__PURE__*/ React.createElement(
    "svg",
    props,
    /*#__PURE__*/ React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M22.707 1.293C22.3163 0.902335 21.683 0.902335 21.2923 1.293L18.5853 4H4C3.20508 4.00237 2.4434 4.31921 1.8813 4.8813C1.31921 5.4434 1.00237 6.20508 1 7V17C1.00237 17.7949 1.31921 18.5566 1.8813 19.1187C2.15551 19.3929 2.47722 19.6087 2.82711 19.7582L1.293 21.2923C0.902335 21.683 0.902335 22.3163 1.293 22.707C1.68366 23.0977 2.31704 23.0977 2.7077 22.707L22.707 2.7077C23.0977 2.31704 23.0977 1.68366 22.707 1.293ZM6.23522 16.3501L4.58529 18H4C3.73478 18 3.48043 17.8946 3.29289 17.7071C3.10536 17.5196 3 17.2652 3 17V13.96C3.95201 14.244 4.81732 14.7628 5.51631 15.4688C5.78465 15.7398 6.02517 16.0351 6.23522 16.3501ZM9.29273 13.2926L13.2926 9.29273C13.2451 9.27005 13.1969 9.24858 13.1481 9.22836C12.5999 9.0013 11.9967 8.94189 11.4147 9.05764C10.8328 9.1734 10.2982 9.45912 9.87868 9.87868C9.45912 10.2982 9.1734 10.8328 9.05764 11.4147C8.94189 11.9967 9.0013 12.5999 9.22836 13.148C9.24858 13.1969 9.27005 13.245 9.29273 13.2926ZM3 10.04V7C3 6.73478 3.10536 6.48043 3.29289 6.29289C3.48043 6.10536 3.73478 6 4 6H7C6.7255 6.95479 6.21529 7.82522 5.51631 8.53119C4.81732 9.23717 3.95201 9.75602 3 10.04Z",
      fill: "currentColor",
    }),
    /*#__PURE__*/ React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M21 10.04C20.3255 9.8388 19.6946 9.51972 19.1354 9.09973L14.2435 13.9917C14.2042 14.036 14.1634 14.0792 14.1213 14.1213C14.0792 14.1634 14.036 14.2042 13.9917 14.2435L8.23517 20H20C20.7949 19.9976 21.5566 19.6808 22.1187 19.1187C22.6808 18.5566 22.9976 17.7949 23 17V7C22.9985 6.50371 22.8745 6.02038 22.6447 5.59048L21 7.23517V10.04ZM21 17C21 17.2652 20.8946 17.5196 20.7071 17.7071C20.5196 17.8946 20.2652 18 20 18H17C17.2745 17.0452 17.7847 16.1748 18.4837 15.4688C19.1827 14.7628 20.048 14.244 21 13.96V17Z",
      fill: "currentColor",
    })
  );
};
NoCosts24.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
};
const sizeMap = {
  24: NoCosts24,
};
export function NoCosts(_ref) {
  let { size = "24" } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const Icon = sizeMap[size] || sizeMap["24"];
  if (
    process.env.NODE_ENV !== "production" &&
    process.env.NODE_ENV !== "test" &&
    !sizeMap[size]
  ) {
    throw new Error(
      "The '".concat(
        size,
        "' size is not supported by the 'NoCosts' icon. Please use one of the available sizes: '24'."
      )
    );
  }
  return /*#__PURE__*/ React.createElement(Icon, props);
}
